export default __webpack_public_path__ + "static/media/ButterflyPage1.cdb58e01.txt";